import {
  ArrowDownWideNarrow,
  ArrowUpDown,
  ArrowUpWideNarrow,
} from 'lucide-react';
import React from 'react';
import { useTableStoreContext } from '@/components/table/contexts/TableContext.tsx';
import { clsx } from 'clsx';

const SortColumnAction = ({ fieldId }: { fieldId: string }) => {
  const pageRequest = useTableStoreContext((state) => state.pageRequest);
  const setPageRequest = useTableStoreContext((state) => state.setPageRequest);
  const tableDefinition = useTableStoreContext(
    (state) => state.tableDefinition,
  );

  const isSortable =
    tableDefinition.fields?.find((fd) => fd.fieldId === fieldId)?.sortable ??
    false;

  if (!isSortable) {
    return null;
  }

  const handleSort = () => {
    if (pageRequest.sortByFieldId === fieldId) {
      if (pageRequest.sortDirection === 'DESC') {
        setPageRequest({ ...pageRequest, sortDirection: 'ASC' });
      } else {
        setPageRequest({
          ...pageRequest,
          sortByFieldId: undefined,
          sortDirection: 'DESC',
        });
      }
    } else {
      setPageRequest({
        ...pageRequest,
        sortByFieldId: fieldId,
        sortDirection: 'DESC',
      });
    }
  };

  const isActive = pageRequest.sortByFieldId === fieldId;
  return (
    <button
      // Kolor idzie jedną gałęzią, nie dwiema klasami naraz: `[&>svg]:text-*`
      // mają równą specyficzność, więc o zwycięzcy decydowałaby kolejność
      // w arkuszu — a Tailwind sortuje warianty arbitralne alfabetycznie
      // i `neutral-400` przebijało `accent-600` na aktywnej kolumnie.
      //
      // Przycisk zostaje w układzie (przezroczysty), zamiast znikać przez
      // `hidden`: inaczej nagłówek skacze przy najechaniu, a sortowania nie
      // da się uruchomić z klawiatury.
      className={clsx(
        'rounded-sm p-1 opacity-0 transition hover:bg-neutral-200 focus-visible:opacity-100 group-hover:opacity-100 [&>svg]:size-4',
        isActive
          ? 'opacity-100 [&>svg]:text-accent-600'
          : '[&>svg]:text-neutral-400',
      )}
      onClick={handleSort}
      aria-label="Sortuj kolumnę"
    >
      {isActive ? (
        pageRequest.sortDirection === 'ASC' ? (
          <ArrowUpWideNarrow />
        ) : (
          <ArrowDownWideNarrow />
        )
      ) : (
        <ArrowUpDown />
      )}
    </button>
  );
};

export default SortColumnAction;
